<template>
  <div class="config-list">
    <div class="config-list-desktop">
      <div class="config-tabs">
        <div
          class="config-tab"
          @click="setCurrentTab(1)"
          :class="{ 'tab-selected': currentConfig == 1 }"
        >
          <div class="config-tab-label">
            <span class="material-symbols-rounded">settings</span>Configurar
            taxa
          </div>
          <i
            class="fa fa-angle-right"
            style="margin-right: 24px; color: #5d758d"
          ></i>
        </div>
        <div
          v-if="showEasyPayment"
          class="config-tab"
          @click="setCurrentTab(2)"
          :class="{ 'tab-selected': currentConfig == 2 }"
        >
          <div class="config-tab-label">
            <span class="material-symbols-rounded">attach_money</span>Pagamento
            dos presentes
          </div>
          <i
            class="fa fa-angle-right"
            style="margin-right: 24px; color: #5d758d"
          ></i>
        </div>
        <div
          class="config-tab"
          @click="setCurrentTab(3)"
          :class="{ 'tab-selected': currentConfig == 3 }"
        >
          <div class="config-tab-label">
            <span class="material-symbols-rounded">visibility</span>
            Visibilidade da lista
          </div>
          <i
            class="fa fa-angle-right"
            style="margin-right: 24px; color: #5d758d"
          ></i>
        </div>
        <div
          class="config-tab"
          @click="setCurrentTab(4)"
          :class="{ 'tab-selected': currentConfig == 4 }"
        >
          <div class="config-tab-label">
            <i class="fa fa-arrow-down-a-z"></i>Exibição dos presentes
          </div>
          <i
            class="fa fa-angle-right"
            style="margin-right: 24px; color: #5d758d"
          ></i>
        </div>
      </div>
      <div class="config-content">
        <div v-if="currentConfig == 1">
          <div class="tab-one-numbers columns">
            <div class="column is-one-third tab-one-labels">
              <div class="numbers-title">Taxa da lista</div>
              <div>
                <span class="numbers-value"
                  >{{ taxTransactionFormatted }}% </span
                ><span v-if="isTaxPromotional" class="numbers-title"
                  >(valor promocional)</span
                >
              </div>
            </div>
            <div class="right-bordered"></div>
            <div class="column is-one-third tab-one-labels">
              <div class="numbers-title">Custo por saque</div>
              <div class="numbers-value">R$ 0,00</div>
            </div>
            <div class="right-bordered"></div>
            <div class="column is-one-third tab-one-labels">
              <div class="numbers-title">Quantidade de saques</div>
              <div class="numbers-value">Ilimitado</div>
            </div>
          </div>
          <div class="tab-one-subtitle">
            Defina quem irá assumir a taxa dos presentes:
          </div>
          <div class="tab-one-card-options">
            <div class="tab-one-card-content" style="width: inherit">
              <b-field>
                <b-radio
                  v-model="checkboxTax"
                  @change.native="configTaxes('B')"
                  native-value="B"
                ></b-radio>
              </b-field>
              <div style="text-align: left">
                <div class="tab-one-card-content-label">
                  Repassar a taxa dos presentes para os convidados
                </div>
                <div class="tab-one-card-content-sublabel">
                  A taxa será embutida no valor dos seus presentes e o convidado
                  verá apenas o valor total.
                </div>
              </div>
            </div>
            <div class="recommended">recomendado</div>
          </div>
          <div class="tab-one-card-options">
            <div class="tab-one-card-content">
              <b-field>
                <b-radio
                  v-model="checkboxTax"
                  @change.native="configTaxes('A')"
                  native-value="A"
                ></b-radio>
              </b-field>
              <div style="text-align: left">
                <div class="tab-one-card-content-label">
                  Queremos assumir a taxa dos presentes
                </div>
                <div class="tab-one-card-content-sublabel">
                  Vocês receberão o valor do presente na Carteira já com o
                  desconto da taxa.
                </div>
              </div>
            </div>
          </div>
          <div class="tab-one-footer">
            Caso vocês alterem esta configuração, ela será aplicada apenas para
            os novos presentes recebidos.
          </div>
        </div>
        <div v-if="currentConfig == 2">
          <p class="tab-two-label">
            Defina abaixo como deverá ser aplicada a taxa de pagamento dos seus
            presentes. Em ambos os casos,
            <span> a taxa será paga pelos convidados.</span>
          </p>
          <div class="tab-one-card-options">
            <div class="tab-one-card-content">
              <b-field>
                <b-radio
                  v-model="checkboxPayment"
                  @change.native="configPayment('juros')"
                  native-value="juros"
                ></b-radio>
              </b-field>
              <div style="text-align: left">
                <div class="tab-one-card-content-label">
                  Pagamento convencional
                </div>
                <div class="tab-one-card-content-sublabel">
                  Seus convidados podem parcelar em até 6x (juros de 2,99% por
                  parcela).
                </div>
              </div>
            </div>
          </div>
          <div class="tab-one-card-options">
            <div class="tab-one-card-content" style="width: inherit">
              <b-field class="mt-1">
                <b-radio
                  v-model="checkboxPayment"
                  @change.native="configPayment('embutida')"
                  native-value="embutida"
                ></b-radio>
              </b-field>
              <div style="text-align: left">
                <div class="tab-one-card-content-label">
                  Pagamento facilitado
                </div>
                <div class="tab-one-card-content-sublabel">
                  Seus convidados podem parcelar em até 6x (acréscimo único de
                  5,99% embutido no valor dos presentes).
                  <p class="my-3 tab-two-alert">
                    O acréscimo será embutido em todas as formas de pagamento,
                    incluindo PIX, boleto e pagamentos em 1x no cartão.
                  </p>
                  <button
                    @click="checkBenefits = !checkBenefits"
                    class="button-action mb-2"
                    type="button"
                  >
                    Confira as vantagens

                    <base-icon
                      class="ml-2 icon"
                      :name="
                        checkBenefits
                          ? 'painel/chevron-up-icon'
                          : 'painel/chevron-down-icon'
                      "
                    />
                  </button>
                  <transition name="fade">
                    <div v-if="checkBenefits" class="mb-4">
                      <easy-installment-simulator :tax="taxTransaction">
                      </easy-installment-simulator>
                    </div>
                  </transition>
                </div>
              </div>
            </div>
            <div class="recommended">recomendado</div>
          </div>
          <div class="tab-one-footer">
            Caso vocês alterem esta configuração, ela será aplicada apenas para
            os novos presentes recebidos.
          </div>
        </div>
        <div v-if="currentConfig == 3">
          <div class="tab-two-published-list">
            <span style="color: #5d758d; font-weight: 700"
              >Lista publicada: &nbsp;
            </span>
            <div style="color: #e583a2; font-weight: 700">
              {{ published ? ' Sim' : ' Não' }}
            </div>
            <b-switch
              @input="$refs.convincingDeactivatingList.open(published)"
              class="switch-csr"
              v-model="published"
              style="margin-left: 10px"
            ></b-switch>
          </div>
          <b-notification
            v-if="published"
            type="is-success is-light"
            role="alert"
            class="mt-4"
            :closable="false"
          >
            <strong>
              Seus presentes estão visíveis e disponíveis para compra no seu
              site.
            </strong>
          </b-notification>
          <b-notification
            v-else
            type="is-warning is-light"
            role="alert"
            class="mt-4"
            :closable="false"
          >
            <strong>
              Os presentes não estão exibidos no site para os convidados. Para
              exibí-los, publique a sua lista.
            </strong>
          </b-notification>
        </div>
        <div v-if="currentConfig == 4">
          <section>
            <div class="tab-three-label">
              Como vocês querem que os seus convidados vejam os presentes?
            </div>
            <div class="tab-three-items">
              <b-radio
                v-model="checkboxOrder"
                size="is-small"
                native-value="valor_final_com_taxa_asc"
                @change.native="editGiftListOrder('valor_final_com_taxa_asc')"
              ></b-radio>
              <div style="text-align: left">
                <div class="tab-three-sublabel">
                  Do menor para o maior valor (valor crescente)
                </div>
              </div>
            </div>
            <div class="tab-three-items">
              <b-radio
                v-model="checkboxOrder"
                size="is-small"
                native-value="valor_final_com_taxa_desc"
                @change.native="editGiftListOrder('valor_final_com_taxa_desc')"
              ></b-radio>
              <div style="text-align: left">
                <div class="tab-three-sublabel">
                  Do maior para o menor valor (valor decrescente)
                </div>
              </div>
            </div>
            <div class="tab-three-items">
              <b-radio
                v-model="checkboxOrder"
                size="is-small"
                native-value="nome_asc"
                @change.native="editGiftListOrder('nome_asc')"
              ></b-radio>
              <div style="text-align: left">
                <div class="tab-three-sublabel">Ordem alfabética (A-Z)</div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
    <!-- --------------------------------------------------------------->
    <div class="config-list-mobile">
      <section>
        <b-collapse
          class="card card-config"
          animation="slide"
          aria-id="contentIdForA11y1"
          :open="currentConfig == 1"
          @open="currentConfig = 1"
        >
          <template #trigger="props">
            <div
              class=""
              role="button"
              aria-controls="contentIdForA11y1"
              :aria-expanded="props.open"
            >
              <div
                class="config-tab tab-mobile"
                :class="{ 'tab-selected': currentConfig == 1 }"
              >
                <div class="config-tab-label">
                  <span class="material-symbols-rounded">settings</span
                  >Configurar taxa
                </div>
                <a class="card-header-icon">
                  <img :src="props.open ? menuUp : menuDown" />
                </a>
              </div>
            </div>
          </template>

          <div class="card-content content-mobile">
            <div>
              <div class="tab-one-numbers-mobile">
                <div>
                  <div class="numbers-title">Taxa da lista</div>
                  <div style="margin-bottom: 16px">
                    <span class="numbers-value">
                      {{ taxTransactionFormatted }}%
                    </span>
                    <span v-if="isTaxPromotional" class="numbers-title"
                      >(valor promocional)</span
                    >
                  </div>
                </div>
                <hr class="mobile-separator" />
                <div>
                  <div class="numbers-title">Custo por saque</div>
                  <div style="margin-bottom: 16px" class="numbers-value">
                    R$ 0,00
                  </div>
                </div>
                <hr class="mobile-separator" />
                <div>
                  <div class="numbers-title">Quantidade de saques</div>
                  <div class="numbers-value">Ilimitado</div>
                </div>
              </div>
              <div class="tab-one-subtitle">
                Defina quem irá assumir a taxa dos presentes:
              </div>

              <div
                class="tab-one-card-options card-options-mobile"
                style="display: block"
              >
                <div class="recommended-mobile">recomendado</div>
                <div class="tab-one-card-content">
                  <!-- <b-checkbox v-model="checkboxCustom"></b-checkbox> -->
                  <b-radio
                    size="is-small"
                    v-model="checkboxTax"
                    @change.native="configTaxes('B')"
                    native-value="B"
                  ></b-radio>
                  <div style="text-align: left">
                    <div class="tab-one-card-content-label">
                      Repassar a taxa dos presentes para os convidados
                    </div>
                    <div class="tab-one-card-content-sublabel">
                      A taxa será embutida no valor dos seus presentes e o
                      convidado verá apenas o valor total.
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-one-card-options card-options-mobile">
                <div class="tab-one-card-content">
                  <!-- <b-checkbox v-model="checkboxCustom"></b-checkbox> -->
                  <b-radio
                    size="is-small"
                    v-model="checkboxTax"
                    @change.native="configTaxes('A')"
                    native-value="A"
                  ></b-radio>
                  <div style="text-align: left">
                    <div class="tab-one-card-content-label">
                      Queremos assumir a taxa dos presentes
                    </div>
                    <div class="tab-one-card-content-sublabel">
                      Vocês receberão o valor do presente na Carteira já com o
                      desconto da taxa.
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tab-one-footer"
                style="font-size: 16px; color: #5d758d; text-align: justify"
              >
                Caso vocês alterem esta configuração, ela será aplicada apenas
                para os novos presentes recebidos.
              </div>
            </div>
          </div>
        </b-collapse>

        <b-collapse
          v-if="showEasyPayment"
          class="card card-config"
          animation="slide"
          aria-id="contentIdForA11y1"
          :open="currentConfig == 2"
          @open="currentConfig = 2"
        >
          <template #trigger="props">
            <div
              class=""
              role="button"
              aria-controls="contentIdForA11y1"
              :aria-expanded="props.open"
            >
              <div
                class="config-tab tab-mobile"
                :class="{ 'tab-selected': currentConfig == 2 }"
              >
                <div class="config-tab-label">
                  <span class="material-symbols-rounded">attach_money</span>
                  Pagamento dos presentes
                </div>
                <a class="card-header-icon">
                  <img :src="props.open ? menuUp : menuDown" />
                </a>
              </div>
            </div>
          </template>

          <div class="card-content content-mobile">
            <div>
              <p class="tab-two-label">
                Defina abaixo como deverá ser aplicada a taxa de pagamento dos
                seus presentes. Em ambos os casos, a taxa será paga pelos
                convidados.
              </p>
              <div class="tab-one-card-options card-options-mobile">
                <div class="tab-one-card-content">
                  <!-- <b-checkbox v-model="checkboxCustom"></b-checkbox> -->
                  <b-radio
                    size="is-small"
                    v-model="checkboxPayment"
                    @change.native="configPayment('juros')"
                    native-value="juros"
                  ></b-radio>
                  <div style="text-align: left">
                    <div class="tab-one-card-content-label">
                      Pagamento convencional
                    </div>
                    <div class="tab-one-card-content-sublabel">
                      Seus convidados podem parcelar em até 6x (juros de 2,99%
                      por parcela).
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tab-one-card-options card-options-mobile"
                style="display: block"
              >
                <div class="recommended-mobile">recomendado</div>
                <div class="tab-one-card-content" style="width: inherit">
                  <b-field class="mt-1">
                    <b-radio
                      v-model="checkboxPayment"
                      @change.native="configPayment('embutida')"
                      native-value="embutida"
                    ></b-radio>
                  </b-field>
                  <div style="text-align: left">
                    <div class="tab-one-card-content-label">
                      Pagamento facilitado
                    </div>
                    <div class="tab-one-card-content-sublabel">
                      Seus convidados podem parcelar em até 6x (acréscimo único
                      de 5,99% embutido no valor dos presentes).
                      <p class="my-3 tab-two-alert">
                        O acréscimo será embutido em todas as formas de
                        pagamento, incluindo PIX, boleto e pagamentos em 1x no
                        cartão.
                      </p>
                      <div class="has-text-centered">
                        <button
                          @click="checkBenefits = !checkBenefits"
                          class="button-action mb-2"
                          type="button"
                          style="margin-left: -16px"
                        >
                          Confira as vantagens

                          <base-icon
                            class="ml-2 icon"
                            :name="
                              checkBenefits
                                ? 'painel/chevron-up-icon'
                                : 'painel/chevron-down-icon'
                            "
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <transition name="fade">
                  <div v-if="checkBenefits" class="mb-4 ml-4">
                    <easy-installment-simulator :tax="taxTransaction">
                    </easy-installment-simulator>
                  </div>
                </transition>
              </div>
              <div
                class="tab-one-footer"
                style="font-size: 16px; color: #5d758d; text-align: justify"
              >
                Caso vocês alterem esta configuração, ela será aplicada apenas
                para os novos presentes recebidos.
              </div>
            </div>
          </div>
        </b-collapse>

        <b-collapse
          class="card card-config"
          animation="slide"
          aria-id="contentIdForA11y2"
          :open="currentConfig == 3"
          @open="currentConfig = 3"
        >
          <template #trigger="props">
            <div
              class=""
              role="button"
              aria-controls="contentIdForA11y2"
              :aria-expanded="props.open"
            >
              <div
                class="config-tab tab-mobile"
                :class="{ 'tab-selected': currentConfig == 3 }"
              >
                <div class="config-tab-label">
                  <span class="material-symbols-rounded">visibility</span>
                  Visibilidade da lista
                </div>
                <a class="card-header-icon">
                  <img :src="props.open ? menuUp : menuDown" />
                </a>
              </div>
            </div>
          </template>

          <div class="card-content">
            <div class="card-text-style">
              <div class="tab-two-published-list published-list-mobile">
                <span style="color: #5d758d; font-weight: 700"
                  >Lista publicada: &nbsp;
                </span>
                <div style="color: #e583a2; font-weight: 700">
                  {{ published ? ' Sim' : ' Não' }}
                </div>
                <b-switch
                  class="switch-csr"
                  @input="$refs.convincingDeactivatingList.open(published)"
                  v-model="published"
                  style="margin-left: 10px"
                ></b-switch>
              </div>
              <b-notification
                v-if="published"
                type="is-success is-light"
                role="alert"
                class="mt-3"
                :closable="false"
              >
                <strong>
                  Seus presentes estão visíveis e disponíveis para compra no seu
                  site.
                </strong>
              </b-notification>
              <b-notification
                v-else
                type="is-warning is-light"
                role="alert"
                class="mt-3"
                :closable="false"
              >
                <strong>
                  Os presentes não estão exibidos no site para os convidados.
                  Para exibí-los, publique a sua lista.
                </strong>
              </b-notification>
            </div>
          </div>
        </b-collapse>

        <b-collapse
          class="card card-config"
          animation="slide"
          aria-id="contentIdForA11y3"
          :open="currentConfig == 4"
          @open="currentConfig = 4"
        >
          <template #trigger="props">
            <div
              class=""
              role="button"
              aria-controls="contentIdForA11y3"
              :aria-expanded="props.open"
            >
              <div
                class="config-tab tab-mobile"
                :class="{ 'tab-selected': currentConfig == 4 }"
              >
                <div class="config-tab-label">
                  <i class="fa fa-arrow-down-a-z"></i>Exibição dos presentes
                </div>
                <a class="card-header-icon">
                  <img :src="props.open ? menuUp : menuDown" />
                </a>
              </div>
            </div>
          </template>

          <div class="card-content">
            <div class="card-text-style">
              <section>
                <div class="tab-three-label label-mobile">
                  Como vocês querem que os seus convidados vejam os presentes?
                </div>
                <div class="tab-three-items">
                  <b-radio
                    v-model="checkboxOrder"
                    size="is-small"
                    native-value="valor_final_com_taxa_asc"
                    @change.native="
                      editGiftListOrder('valor_final_com_taxa_asc')
                    "
                  ></b-radio>
                  <div style="text-align: left">
                    <div class="tab-three-sublabel">
                      Do menor para o maior valor (valor crescente)
                    </div>
                  </div>
                </div>
                <div class="tab-three-items">
                  <b-radio
                    v-model="checkboxOrder"
                    size="is-small"
                    native-value="valor_final_com_taxa_desc"
                    @change.native="
                      editGiftListOrder('valor_final_com_taxa_desc')
                    "
                  ></b-radio>
                  <div style="text-align: left">
                    <div class="tab-three-sublabel">
                      Do maior para o menor valor (valor decrescente)
                    </div>
                  </div>
                </div>
                <div class="tab-three-items">
                  <b-radio
                    v-model="checkboxOrder"
                    size="is-small"
                    native-value="nome_asc"
                    @change.native="editGiftListOrder('nome_asc')"
                  ></b-radio>
                  <div style="text-align: left">
                    <div class="tab-three-sublabel">Ordem alfabética (A-Z)</div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </b-collapse>
      </section>
    </div>
    <ModalConvincingDeactivatingList
      @confirmed="editGiftListVisibility"
      @keep="() => (published = true)"
      ref="convincingDeactivatingList"
    />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ModalConvincingDeactivatingList from './ModalConvincingDeactivatingList/ModalConvincingDeactivatingList.vue'
import menuUp from '@/assets/img/chevron-up.svg'
import menuDown from '@/assets/img/chevron-down.svg'
import GiftsApi from '@/lib/api/Gifts'
import { EasyInstallmentSimulator } from 'casar-web-components'

const GIFT_LIST_TAX_DEFAULT = 3.89

export default {
  components: {
    ModalConvincingDeactivatingList,
  },

  data() {
    return {
      menuUp,
      menuDown,
      currentConfig: 1,
      checkboxOrder: 'nome_asc',
      checkboxTax: 'B',
      checkboxPayment: 'juros',
      checkBenefits: false,
      showEasyPayment: false,
      published: true,
      taxTransaction: null,
    }
  },

  mounted() {
    this.getTaxes()
    this.getGiftListConfig()
    this.changeTabByQuery()
  },

  computed: {
    ...mapGetters({
      wedId: 'app/getWedId',
      logonToken: 'app/logonToken',
    }),

    taxTransactionFormatted() {
      const tax = this.taxTransaction || GIFT_LIST_TAX_DEFAULT
      return tax.toString().replace('.', ',')
    },

    isTaxPromotional() {
      return this.taxTransaction < GIFT_LIST_TAX_DEFAULT
    },
  },

  methods: {
    ...mapActions({
      setSaving: 'gifts/setSaving',
      notification: 'app/setNotification',
    }),

    changeTabByQuery() {
      if (this.$route.query.tab) {
        switch (this.$route.query.tab) {
          case 'configurar-taxa':
            this.setCurrentTab(1)
            break
          case 'visibilidade-da-lista':
            this.setCurrentTab(2)
            break
          case 'exibicao-dos-presentes':
            this.setCurrentTab(3)
            break
        }
      }
    },

    setCurrentTab(tab) {
      this.currentConfig = tab
    },

    getTaxes() {
      const giftsApi = new GiftsApi(this.logonToken)

      giftsApi
        .getTaxes()
        .then((response) => {
          if (!response.data) throw 'Error on get taxes'
          this.showEasyPayment =
            response.data.virtual_rate_configs_type == 'parcelamento'
          this.checkboxPayment =
            response.data.virtual_rate_installment_type || 'juros'
          this.taxTransaction = response.data.virtual_rate_transaction_custom
          this.checkboxTax = response.data.virtual_rate_option || 'B'
        })
        .catch((error) => console.error(error))
    },

    getGiftListConfig() {
      const giftsApi = new GiftsApi(this.logonToken)
      giftsApi.getGiftListConfig().then((response) => {
        if (!response.data) throw 'Without "data" on save gift list config'
        this.published = response.data.published
        this.checkboxOrder = response.data.order || 'nome_asc'
      })
    },
    configTaxes(value) {
      this.checkboxTax = value
      let data = {
        virtual_rate_option: this.checkboxTax,
      }
      this.editTaxes(data)
    },
    configPayment(value) {
      let data = {
        virtual_rate_option: this.checkboxTax,
        virtual_rate_installment_type: value,
      }
      this.editTaxes(data)
    },
    editTaxes(data) {
      const giftsApi = new GiftsApi(this.logonToken)
      giftsApi
        .editTaxes(data)
        .then((response) => {
          if (!response.data) throw 'Without "data" on edit gift list taxes'
          this.setSaving(true)
        })
        .catch(() => {
          return this.notification({
            message: 'Erro ao editar taxa. Por favor, tente novamente.',
            show: true,
            class: 'is-error',
          })
        })
    },

    editGiftListOrder(value) {
      const giftsApi = new GiftsApi(this.logonToken)
      giftsApi.editGiftListOrder(value).then((response) => {
        if (!response.data) throw 'Without "data" on edit gift list order'
        this.setSaving(true)
      })
    },
    editGiftListVisibility() {
      const giftsApi = new GiftsApi(this.logonToken)
      giftsApi.editGiftListVisibility(this.published).then((response) => {
        if (!response.data) throw 'Without "data" on edit gift list visibility'
        this.setSaving(true)
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.config-list-mobile {
  display: none;
  @media (max-width: 930px) {
    display: block;
  }
}

.tab-mobile {
  background-color: #fff !important;
  justify-content: space-between;
  width: 100% !important;
}

.tab-one-numbers-mobile {
  background-color: $neutrallightest;
  padding-top: 24px;
  padding-bottom: 24px;
  border-radius: 16px;
  text-align: center;
}

.published-list-mobile {
  margin-top: 0px !important;
  width: auto !important;
  margin-left: 0px !important;
}

.tab-two-alert {
  padding: 16px;
  background-color: rgba($supportlight, 20%);
  border-radius: 8px;
}
.card-options-mobile {
  height: auto !important;
  padding-bottom: 24px;
  padding-top: 24px;
  padding-right: 16px;
}

.label-mobile {
  margin-top: -20px !important;
  margin-left: 16px !important;
  margin-bottom: 16px !important;
}
.tab-three-items {
  margin-left: 16px !important;
  margin-bottom: 8px !important;
}

.recommended-mobile {
  background: $primary;
  border-radius: 8px;
  width: 114px;
  height: 33px;
  color: #fff;
  margin-right: -16px;
  margin-top: -24px;
  float: right;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
}
.card-config {
  margin-bottom: 24px;
  border-radius: 16px;
}

.config-list-desktop {
  display: flex;
  @media (max-width: 930px) {
    display: none;
  }
}

.content-mobile {
  padding-top: 0px;
}

.mobile-separator {
  display: inline-flex;
  width: 32px;
  border: 1px solid rgba(180, 197, 214, 0.5);
  margin-bottom: 16px;
}
.config-tab-label {
  display: flex;
  align-items: center;
  margin-left: 24px;
  font-size: 16px;

  span,
  i {
    margin-right: 8px;
    color: $neutral;
  }

  i {
    font-size: 18px;
  }
}
.config-list {
  margin-top: 48px;
  margin-bottom: 60px;
}

.config-content {
  border: 1px solid rgba(180, 197, 214, 0.5);
  border-radius: 16px;
  min-height: 264px !important;
  width: 100%;
  padding-left: 24px;
  padding-right: 24px;
  height: fit-content;
}

.config-tabs {
  margin-right: 16px;
  color: $neutral;
}
.config-tab {
  background: #fff;
  border: 1px solid #dde7f1;
  border-radius: 16px;
  width: 320px;
  height: 72px;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: $neutral;
  justify-content: space-between;

  @media (min-width: 600px) and (min-width: 800px) {
    font-size: 14px;
  }
}

.tab-selected {
  background: $neutrallightest;
  font-weight: 700;

  span,
  i {
    color: $primary;
  }
}
.recommended {
  background: $primary;
  border-radius: 8px;
  //width: 114px;
  height: 33px;
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  top: 0;
  left: auto;
  bottom: auto;
  right: 0;
  position: absolute;
  align-items: center;
  padding: 8px;
  //margin-left: 160px;
}

.tab-one-labels {
  display: grid;
  margin-top: 48px;
  text-align: center;
}

.right-bordered {
  border-right: 1px solid $neutrallight;
  height: 32px;
  margin-top: 70px;
  vertical-align: middle;
}
.numbers-title {
  color: $neutral;
  font-size: 16px;
  font-weight: 400;
}
.numbers-value {
  color: $primary;
  font-size: 18px;
  font-weight: 700;
}

.tab-one-subtitle {
  color: $neutral;
  margin-top: 48px;
  text-align: left;
  margin-bottom: 24px;
  font-weight: 700;
  font-size: 16px;
}

.tab-one-card-options {
  background: #ffffff;
  border: 1px solid rgba(180, 197, 214, 0.5);
  border-radius: 8px;
  width: 100%;
  height: auto;
  min-height: 92px;
  position: relative;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
}

.tab-one-card-content {
  display: inline-flex;
  align-items: start;
  padding-top: 16px;
  padding: 24px;

  @media (min-width: 769px) and (max-width: 936px) {
    padding: 28px 24px;
  }
  @media (max-width: 768px) {
    padding: 0;
    padding-left: 10px;
  }

  .tab-one-card-content-label {
    color: $neutral;
    font-weight: 700;
    font-size: 16px;
  }

  .tab-one-card-content-sublabel {
    font-weight: 400;
  }
}
.tab-one-footer {
  text-align: left;
  margin-bottom: 24px;
}

.tab-two-published-list {
  background: #ffffff;
  border: 1px solid #dde7f1;
  border-radius: 8px;
  width: 280px;
  height: 56px;
  display: flex;
  align-items: center;
  padding-left: 16px;
  margin-top: 32px;
}

.tab-two-label {
  color: $neutral;
  margin-top: 24px;
  font-size: 14px;
  text-align: left;
  margin-bottom: 24px;

  span {
    font-weight: 700;
  }
}

.button-action {
  height: 40px;
  font-size: 14px;
  font-weight: bold;
  line-height: 1;
  color: $support;
  border: 0;
  cursor: pointer;
  background-color: transparent;
  &:hover,
  &:focus {
    border: 0;
    color: $supportdark;
  }
  .icon {
    margin-bottom: -8px;
    width: 15px;
  }
}

.tab-three-label {
  color: $neutral;
  margin-top: 32px;
  margin-left: 17px;
  font-weight: 700;
  text-align: left;
  margin-bottom: 24px;
}

.tab-three-sublabel {
  font-weight: 400;
}

.tab-three-items {
  display: flex;
  align-items: center;
  font-weight: 400;
  margin-left: 24px;
  margin-bottom: 40px;
}
</style>
